/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gateway_Spending_Cap_Empty_TitleInputs */



/**
* | output |
* | --- |
* | "Spending Cap" |
*
* @param {Gateway_Spending_Cap_Empty_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const gateway_spending_cap_empty_title = /** @type {((inputs?: Gateway_Spending_Cap_Empty_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gateway_Spending_Cap_Empty_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausgabenlimit")
	return /** @type {LocalizedString} */ ("Spending Cap")
});